export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1775250869743-d08c72844f6e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2Nzd8MHwxfHNlYXJjaHwxfHxkYXJrJTIwdGhlYXRlciUyMHN0YWdlJTIwd2FybSUyMHNwb3RsaWdodHxlbnwwfHx8fDE3Nzc0OTM1OTJ8MA&ixlib=rb-4.1.0&q=85",
  pillarMusic:
    "https://images.unsplash.com/photo-1597047215612-4523973fbac2?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDR8MHwxfHNlYXJjaHwyfHxjbGFzc2ljYWwlMjB2aW9saW4lMjB3ZWRkaW5nJTIwZWxlZ2FudHxlbnwwfHx8fDE3Nzc0OTM1OTJ8MA&ixlib=rb-4.1.0&q=85",
  pillarIt:
    "https://images.pexels.com/photos/4864249/pexels-photo-4864249.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  pillarEducation:
    "https://images.unsplash.com/photo-1513883049090-d0b7439799bf?w=1400&q=80",
  brandWedding:
    "https://images.unsplash.com/photo-1519741497674-611481863552?w=1600&q=85",
  brandEnsemble:
    "https://images.unsplash.com/photo-1465847899084-d164df4dedc6?w=1600&q=85",
  // Official team photos from proscenio.solutions (Wix CDN)
  teamStefano:
    "https://static.wixstatic.com/media/952455_f457b4b39cc440e2be864b6f5493d19a~mv2.jpg/v1/fill/w_800,h_800,al_c,q_85,usm_0.66_1.00_0.01,enc_auto/952455_f457b4b39cc440e2be864b6f5493d19a~mv2.jpg",
  teamLucia:
    "https://customer-assets.emergentagent.com/job_theatre-tech-hub/artifacts/755d3jvr_WhatsApp%20Image%202026-04-15%20at%2000.06.21.jpeg",
  // No official photo available for the IT technician — rendered as monogram placeholder
  teamTech: null,
};
